import { render, staticRenderFns } from "./OidcCallbackPage.vue?vue&type=template&id=2c5fafec"
import script from "./OidcCallbackPage.vue?vue&type=script&lang=ts"
export * from "./OidcCallbackPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports